import { env } from '../../utils';
import Development from './configure.dev';
import Production from './configure.prod';

export default env('APP_DEBUG') ? Development : Production;
